import { Component, inject, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, NgForm, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { LoadingService } from "../shared/loading-spinner/loading.service";
import { LoginReturnError, LoginService } from "./login.service";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "projects/htl-part/src/environments/environment";
import { version } from "../../../../../package.json";
import { NgxTurnstileComponent } from "ngx-turnstile";

@Component({
    selector: "app-login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.scss"],
    standalone: false,
})
export class LoginComponent implements OnInit {
    protected readonly environment = environment;

    private _formBuilder = inject(FormBuilder);
    private _loginService = inject(LoginService);
    private _router = inject(Router);
    private _loadingService = inject(LoadingService);
    private _translate = inject(TranslateService);

    @ViewChild("loginForm") loginForm: NgForm;
    @ViewChild("turnstile") turnstile: NgxTurnstileComponent;
    public loginFormGroup: FormGroup;
    public errorMessage: string;
    public siteKey: string = environment.turnstileSiteKey;
    public hidePassword: boolean = true;
    public turnstileFailed: boolean = false;
    public readonly appVersion: string = version;

    constructor() {
        if (this._loginService.currentUserDataValue) {
            if (this._loginService.currentUserDataValue.sessionToken) {
                this._router.navigate(["/flights"]);
            }
        }
        this.loginFormGroup = this._formBuilder.group({
            username: ["", Validators.required],
            password: ["", Validators.required],
        });
        if (!environment.local) {
            this.loginFormGroup.addControl("turnstileToken", this._formBuilder.control("", [Validators.required]));
        }
    }

    ngOnInit(): void {}

    onLoginFormSubmit() {
        this.turnstileFailed = false;
        this.loginFormGroup.get("username").setErrors(null);
        if (this.loginForm.valid) {
            this._loginService.loginPost(this.loginForm.value.username.trim(), this.loginForm.value.password.trim(), this.loginForm.value.turnstileToken).subscribe(
                (res) => {
                    this._loginService.userData.subscribe((userData) => {
                        if (userData) {
                            if (res.htlAccount.status === 1) {
                                this._router.navigate(["/flights"]).then(() => {
                                    this._loadingService.setHttpProgressStatus(false);
                                });
                            } else if (res.htlAccount.status === 2) {
                                this._router.navigate(["/create-password"]).then(() => {
                                    this._loadingService.setHttpProgressStatus(false);
                                });
                            }
                        }
                    });
                },
                (errorObject: LoginReturnError) => {
                    console.log(errorObject);
                    if (errorObject.status === 615) {
                        this.turnstileFailed = true;
                    } else {
                        this.errorMessage = this._translate.instant("LOGIN." + errorObject.stringCode);
                        if (errorObject.stringCode === "multipleFailedLoginError") {
                            if (typeof errorObject.value === "object") {
                                this.errorMessage = this._translate.instant("LOGIN." + errorObject.stringCode).replace("%value%", errorObject.value.waitTime);
                            }
                        }
                        this.loginFormGroup.controls["username"].setErrors({ notValid: true });
                    }
                    this.resetTurnstile();
                },
            );
        }
    }

    retryTurnstile() {
        this.turnstileFailed = false;
        this.resetTurnstile();
    }

    // The backend consumes the token on every login attempt, even a failed one, so a new token is needed before retrying.
    private resetTurnstile() {
        this.turnstile?.reset();
    }
}
